/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,e,i){this.object=t,this.geometryId=e,this.primitiveIndex=i}}export{t as ObjectTarget};
